module.exports = __webpack_public_path__ + "media/images/zip_file-584cb4c9445b911bcc70a2f7d9edf428.png";